import "./src/styles/global.scss"

// or:
// require('./src/styles/global.css')